<template>
  <div class="nav-page" :class="!showbar?'display-none':''">
    <div class="flex-center position-relative " style="z-index: 2000;height: 100%;background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);">
      <img class="swiper-topnav-logo position-absolute" style="left: 20px;top: 5px" src="@/assets/shjk/icon-web-logo.png">
      <div class="swiper-topnav-text flex">
        <p v-for="(item, index) in navMenu" :key="index" class="font-14 cursor" :class="path==item.path?'active':''" @click="menuTap(item)">{{ item.name }}</p>
      </div>
      <div class="swiper-topnav-btn flex-row-center position-absolute">
        <div v-if="showSearch" class="swiper-topnav-btn-input flex-row-center">
          <el-input v-model="searchKey" placeholder="关键字检索" size="normal" @keyup.enter.native="inputChange" />
          <img src="@/assets/shjk/icon-web-search-in.png" @click="inputChange">
        </div>
        <img v-else class="flex-shrink cursor" src="@/assets/shjk/icon-web-search.png" @click="showSearch = !showSearch">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSearch: false,
      searchKey: '',
      showbar: true,
      navMenu: [{
        name: '首页',
        path: '/',
        index: 0
      }, {
        name: '数字资源',
        path: '/source',
        index: 1
      }, {
        name: '记忆本体',
        path: '/entity',
        index: 2
      }, {
        name: '特色专题',
        path: '/topic',
        index: 3
      }]

    }
  },
  computed: {
    path() {
      return this.$route.path
    }
  },
  watch: {
    $route(to, from) {
      this.matchRouter(to.path)
    }
  },
  created() {
    this.matchRouter(this.$router.currentRoute.path)
  },

  methods: {
    menuTap(item) {
      if (item.path === this.$route.path) {
        return
      } else {
        if (item.path === '/source' || item.path === '/entity') {
          this.$router.push({ path: item.path })
        } else {
          this.$router.push({ path: item.path, query: { key: item.index }})
        }
      }
    },
    inputChange(e) {
      this.showSearch = !this.showSearch
      if (this.searchKey) {
        this.$router.push({
          path: '/search',
          query: { key: this.searchKey }
        })
      }
    },
    matchRouter(path) {
      this.showbar = true
      if (path === '/' || path === '/topic/info') {
        this.showbar = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input__inner {
  color: #fff;
  font-size: 12px;
  border: none;
  height: 34px;
  background-color: rgba($color: #fff, $alpha: 0);
}
  .nav-page {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 1220px;
    height: 60px;
    z-index: 999;
    //background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.7) 100%);
    //backdrop-filter: blur(50px);
    //box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  }

  .swiper-topnav-logo {
    height: 50px;

  }
  .swiper-topnav-text p {
    line-height: 25px;
    color: rgba(255, 255, 255, 0.6);
    margin-right: 25px;
    transition: 0.8s;
  }

  .swiper-topnav-text p:hover {
    color: #fff;
    transition: 800ms;
  }

  .swiper-topnav-text p.active {
    color: #fff;
    transition: 500ms;
  }

  .swiper-topnav-text p:last-child {
    margin: 0;
  }
  .swiper-topnav-btn {
    right: 20px;
  }

  .swiper-topnav-btn-input {
    width: 300px;
    height: 36px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding: 0 10px;
  }

  .swiper-topnav-btn-input input {
    height: 34px;
    outline: none;
    border: none;
    flex: 1;
  }

  .swiper-topnav-btn-input img {
    flex-shrink: 0;
    width: 18px;
    margin-left: 4px;
  }

  .display-none {
    display: none;
  }
</style>
